import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://www.ulcaapp.com';

const SEO = ({
  title,
  description,
  path = '/',
  type = 'website',
  image,
  keywords,
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} | UlcaApp`
    : 'UlcaApp – Hire Skilled Workers & Find Labour Jobs Near You | Plumber, Electrician, Painter';
  const fullDescription =
    description ||
    "UlcaApp – India's #1 labour app to hire skilled workers near you. Find & book verified plumbers, electricians, painters, carpenters instantly. Workers: register free & find jobs near you.";
  const url = `${BASE_URL}${path}`;
  const ogImage = image || `${BASE_URL}/og-image.png`;
  const metaKeywords = keywords || 'UlcaApp, labour app, worker app, find workers near me, hire plumber, electrician near me, painter near me, carpenter near me, skilled workers near me, jobs for workers, labour jobs India';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={metaKeywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="UlcaApp" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
